package org.matthewo.api

import kotlin.jvm.JvmName
import kotlinx.serialization.Serializable
import kotlin.math.roundToInt
import org.matthewo.symbolprocessor.Period.*
import org.matthewo.schema.MetricsMeta
import org.matthewo.schema.games.*
import org.matthewo.math.plus
import org.matthewo.math.convert

@Serializable
data class MetricsCenterStageCRIAPI<N : Number>(
    override val total: N,
    override val npTotal: N,
    override val auto: N,
    override val teleop: N,
    override val endgame: N,
    override val penalty: N,
    override val apPurple: N,
    override val apYellow: N,
    override val apNavigation: N,
    override val apBackstage: N,
    override val apBackdrop: N,
    override val apMosaic: N,
    override val apSet: N,
    override val apSharedBackdrop: N,
    override val apSharedMosaic: N,
    override val apSharedSet: N,
    override val tpBackstage: N,
    override val tpBackdrop: N,
    override val tpMosaic: N,
    override val tpSet: N,
    override val tpSharedBackdrop: N,
    override val tpSharedMosaic: N,
    override val tpSharedSet: N,
    override val epDrone: N,
    override val epHang: N,
    override val epPark: N,
    override val rpCollage: N,
    override val rpMural: N,
    override val rpFinale: N,
) : MetricsAPI<N>, MetricsCenterStageCRI<N> {
    constructor(team1: MetricsCenterStageCRI<N>, team2: MetricsCenterStageCRI<N>) : this(
        total = team1.total + team2.total,
        npTotal = team1.npTotal + team2.npTotal,
        auto = team1.auto + team2.auto,
        teleop = team1.teleop + team2.teleop,
        endgame = team1.endgame + team2.endgame,
        penalty = team1.penalty + team2.penalty,
        apPurple = team1.apPurple + team2.apPurple,
        apYellow = team1.apYellow + team2.apYellow,
        apNavigation = team1.apNavigation + team2.apNavigation,
        apBackstage = team1.apBackstage + team2.apBackstage,
        apBackdrop = team1.apBackdrop + team2.apBackdrop,
        apMosaic = team1.apMosaic + team2.apMosaic,
        apSet = team1.apSet + team2.apSet,
        apSharedBackdrop = team1.apSharedBackdrop + team2.apSharedBackdrop,
        apSharedMosaic = team1.apSharedMosaic + team2.apSharedMosaic,
        apSharedSet = team1.apSharedSet + team2.apSharedSet,
        tpBackstage = team1.tpBackstage + team2.tpBackstage,
        tpBackdrop = team1.tpBackdrop + team2.tpBackdrop,
        tpMosaic = team1.tpMosaic + team2.tpMosaic,
        tpSet = team1.tpSet + team2.tpSet,
        tpSharedBackdrop = team1.tpSharedBackdrop + team2.tpSharedBackdrop,
        tpSharedMosaic = team1.tpSharedMosaic + team2.tpSharedMosaic,
        tpSharedSet = team1.tpSharedSet + team2.tpSharedSet,
        epDrone = team1.epDrone + team2.epDrone,
        epHang = team1.epHang + team2.epHang,
        epPark = team1.epPark + team2.epPark,
        rpCollage = team1.rpCollage + team2.rpCollage,
        rpMural = team1.rpMural + team2.rpMural,
        rpFinale = team1.rpFinale + team2.rpFinale,
    )
    
    companion object {
        inline operator fun <reified N : Number> invoke(team1: MetricsCenterStageCRI<*>, team2: MetricsCenterStageCRI<*>) = MetricsCenterStageCRIAPI(
            total = team1.total.convert<N>() + team2.total.convert<N>(),
            npTotal = team1.npTotal.convert<N>() + team2.npTotal.convert<N>(),
            auto = team1.auto.convert<N>() + team2.auto.convert<N>(),
            teleop = team1.teleop.convert<N>() + team2.teleop.convert<N>(),
            endgame = team1.endgame.convert<N>() + team2.endgame.convert<N>(),
            penalty = team1.penalty.convert<N>() + team2.penalty.convert<N>(),
            apPurple = team1.apPurple.convert<N>() + team2.apPurple.convert<N>(),
            apYellow = team1.apYellow.convert<N>() + team2.apYellow.convert<N>(),
            apNavigation = team1.apNavigation.convert<N>() + team2.apNavigation.convert<N>(),
            apBackstage = team1.apBackstage.convert<N>() + team2.apBackstage.convert<N>(),
            apBackdrop = team1.apBackdrop.convert<N>() + team2.apBackdrop.convert<N>(),
            apMosaic = team1.apMosaic.convert<N>() + team2.apMosaic.convert<N>(),
            apSet = team1.apSet.convert<N>() + team2.apSet.convert<N>(),
            apSharedBackdrop = team1.apSharedBackdrop.convert<N>() + team2.apSharedBackdrop.convert<N>(),
            apSharedMosaic = team1.apSharedMosaic.convert<N>() + team2.apSharedMosaic.convert<N>(),
            apSharedSet = team1.apSharedSet.convert<N>() + team2.apSharedSet.convert<N>(),
            tpBackstage = team1.tpBackstage.convert<N>() + team2.tpBackstage.convert<N>(),
            tpBackdrop = team1.tpBackdrop.convert<N>() + team2.tpBackdrop.convert<N>(),
            tpMosaic = team1.tpMosaic.convert<N>() + team2.tpMosaic.convert<N>(),
            tpSet = team1.tpSet.convert<N>() + team2.tpSet.convert<N>(),
            tpSharedBackdrop = team1.tpSharedBackdrop.convert<N>() + team2.tpSharedBackdrop.convert<N>(),
            tpSharedMosaic = team1.tpSharedMosaic.convert<N>() + team2.tpSharedMosaic.convert<N>(),
            tpSharedSet = team1.tpSharedSet.convert<N>() + team2.tpSharedSet.convert<N>(),
            epDrone = team1.epDrone.convert<N>() + team2.epDrone.convert<N>(),
            epHang = team1.epHang.convert<N>() + team2.epHang.convert<N>(),
            epPark = team1.epPark.convert<N>() + team2.epPark.convert<N>(),
            rpCollage = team1.rpCollage.convert<N>() + team2.rpCollage.convert<N>(),
            rpMural = team1.rpMural.convert<N>() + team2.rpMural.convert<N>(),
            rpFinale = team1.rpFinale.convert<N>() + team2.rpFinale.convert<N>(),
        )
    }
}

inline fun <reified N : Number> MetricsCenterStageCRI<*>.convert() = serialize { convert<N>() }

fun <N : Number> MetricsCenterStageCRI<N>.serialize() = MetricsCenterStageCRIAPI(
    total = total,
    npTotal = npTotal,
    auto = auto,
    teleop = teleop,
    endgame = endgame,
    penalty = penalty,
    apPurple = apPurple,
    apYellow = apYellow,
    apNavigation = apNavigation,
    apBackstage = apBackstage,
    apBackdrop = apBackdrop,
    apMosaic = apMosaic,
    apSet = apSet,
    apSharedBackdrop = apSharedBackdrop,
    apSharedMosaic = apSharedMosaic,
    apSharedSet = apSharedSet,
    tpBackstage = tpBackstage,
    tpBackdrop = tpBackdrop,
    tpMosaic = tpMosaic,
    tpSet = tpSet,
    tpSharedBackdrop = tpSharedBackdrop,
    tpSharedMosaic = tpSharedMosaic,
    tpSharedSet = tpSharedSet,
    epDrone = epDrone,
    epHang = epHang,
    epPark = epPark,
    rpCollage = rpCollage,
    rpMural = rpMural,
    rpFinale = rpFinale,
)

@JvmName("serializeGeneric")
fun <T : Number, R : Number> MetricsCenterStageCRI<T>.serialize(serializer: T.() -> R) = MetricsCenterStageCRIAPI(
    total = total.serializer(),
    npTotal = npTotal.serializer(),
    auto = auto.serializer(),
    teleop = teleop.serializer(),
    endgame = endgame.serializer(),
    penalty = penalty.serializer(),
    apPurple = apPurple.serializer(),
    apYellow = apYellow.serializer(),
    apNavigation = apNavigation.serializer(),
    apBackstage = apBackstage.serializer(),
    apBackdrop = apBackdrop.serializer(),
    apMosaic = apMosaic.serializer(),
    apSet = apSet.serializer(),
    apSharedBackdrop = apSharedBackdrop.serializer(),
    apSharedMosaic = apSharedMosaic.serializer(),
    apSharedSet = apSharedSet.serializer(),
    tpBackstage = tpBackstage.serializer(),
    tpBackdrop = tpBackdrop.serializer(),
    tpMosaic = tpMosaic.serializer(),
    tpSet = tpSet.serializer(),
    tpSharedBackdrop = tpSharedBackdrop.serializer(),
    tpSharedMosaic = tpSharedMosaic.serializer(),
    tpSharedSet = tpSharedSet.serializer(),
    epDrone = epDrone.serializer(),
    epHang = epHang.serializer(),
    epPark = epPark.serializer(),
    rpCollage = rpCollage.serializer(),
    rpMural = rpMural.serializer(),
    rpFinale = rpFinale.serializer(),
)

@JvmName("serializeDouble")
fun MetricsCenterStageCRI<Double>.serialize() = serialize { roundToInt().toShort() }

@JvmName("serializeNumber")
fun MetricsCenterStageCRI<Number>.serialize() = serialize { toShort() }

fun MetricsCenterStageCRI<*>.stringify() = """
        total: $total
        npTotal: $npTotal
        auto: $auto
        teleop: $teleop
        endgame: $endgame
        penalty: $penalty
        apPurple: $apPurple
        apYellow: $apYellow
        apNavigation: $apNavigation
        apBackstage: $apBackstage
        apBackdrop: $apBackdrop
        apMosaic: $apMosaic
        apSet: $apSet
        apSharedBackdrop: $apSharedBackdrop
        apSharedMosaic: $apSharedMosaic
        apSharedSet: $apSharedSet
        tpBackstage: $tpBackstage
        tpBackdrop: $tpBackdrop
        tpMosaic: $tpMosaic
        tpSet: $tpSet
        tpSharedBackdrop: $tpSharedBackdrop
        tpSharedMosaic: $tpSharedMosaic
        tpSharedSet: $tpSharedSet
        epDrone: $epDrone
        epHang: $epHang
        epPark: $epPark
        rpCollage: $rpCollage
        rpMural: $rpMural
        rpFinale: $rpFinale
    """.trimIndent()

object MetricsCenterStageCRIMeta : MetricsMeta<MetricsCenterStageCRI<*>> {
    override val names = linkedMapOf(
        MetricsCenterStageCRI<*>::total to "Total",
        MetricsCenterStageCRI<*>::npTotal to "NP Total",
        MetricsCenterStageCRI<*>::auto to "Auto",
        MetricsCenterStageCRI<*>::teleop to "Teleop",
        MetricsCenterStageCRI<*>::endgame to "Endgame",
        MetricsCenterStageCRI<*>::penalty to "Penalty",
        MetricsCenterStageCRI<*>::apPurple to "Purple",
        MetricsCenterStageCRI<*>::apYellow to "Yellow",
        MetricsCenterStageCRI<*>::apNavigation to "Navigation",
        MetricsCenterStageCRI<*>::apBackstage to "Backstage",
        MetricsCenterStageCRI<*>::apBackdrop to "Backdrop",
        MetricsCenterStageCRI<*>::apMosaic to "Mosaic",
        MetricsCenterStageCRI<*>::apSet to "Set",
        MetricsCenterStageCRI<*>::apSharedBackdrop to "Shared Backdrop",
        MetricsCenterStageCRI<*>::apSharedMosaic to "Shared Mosaic",
        MetricsCenterStageCRI<*>::apSharedSet to "Shared Set",
        MetricsCenterStageCRI<*>::tpBackstage to "Backstage",
        MetricsCenterStageCRI<*>::tpBackdrop to "Backdrop",
        MetricsCenterStageCRI<*>::tpMosaic to "Mosaic",
        MetricsCenterStageCRI<*>::tpSet to "Set",
        MetricsCenterStageCRI<*>::tpSharedBackdrop to "Shared Backdrop",
        MetricsCenterStageCRI<*>::tpSharedMosaic to "Shared Mosaic",
        MetricsCenterStageCRI<*>::tpSharedSet to "Shared Set",
        MetricsCenterStageCRI<*>::epDrone to "Drone",
        MetricsCenterStageCRI<*>::epHang to "Hang",
        MetricsCenterStageCRI<*>::epPark to "Park",
        MetricsCenterStageCRI<*>::rpCollage to "Collage",
        MetricsCenterStageCRI<*>::rpMural to "Mural",
        MetricsCenterStageCRI<*>::rpFinale to "Finale",
    )
    
    override val periods = linkedMapOf(
        MetricsCenterStageCRI<*>::total to ALL,
        MetricsCenterStageCRI<*>::npTotal to ALL,
        MetricsCenterStageCRI<*>::auto to AUTO,
        MetricsCenterStageCRI<*>::teleop to TELEOP,
        MetricsCenterStageCRI<*>::endgame to ENDGAME,
        MetricsCenterStageCRI<*>::penalty to ALL,
        MetricsCenterStageCRI<*>::apPurple to AUTO,
        MetricsCenterStageCRI<*>::apYellow to AUTO,
        MetricsCenterStageCRI<*>::apNavigation to AUTO,
        MetricsCenterStageCRI<*>::apBackstage to AUTO,
        MetricsCenterStageCRI<*>::apBackdrop to AUTO,
        MetricsCenterStageCRI<*>::apMosaic to AUTO,
        MetricsCenterStageCRI<*>::apSet to AUTO,
        MetricsCenterStageCRI<*>::apSharedBackdrop to AUTO,
        MetricsCenterStageCRI<*>::apSharedMosaic to AUTO,
        MetricsCenterStageCRI<*>::apSharedSet to AUTO,
        MetricsCenterStageCRI<*>::tpBackstage to TELEOP,
        MetricsCenterStageCRI<*>::tpBackdrop to TELEOP,
        MetricsCenterStageCRI<*>::tpMosaic to TELEOP,
        MetricsCenterStageCRI<*>::tpSet to TELEOP,
        MetricsCenterStageCRI<*>::tpSharedBackdrop to TELEOP,
        MetricsCenterStageCRI<*>::tpSharedMosaic to TELEOP,
        MetricsCenterStageCRI<*>::tpSharedSet to TELEOP,
        MetricsCenterStageCRI<*>::epDrone to ENDGAME,
        MetricsCenterStageCRI<*>::epHang to ENDGAME,
        MetricsCenterStageCRI<*>::epPark to ENDGAME,
        MetricsCenterStageCRI<*>::rpCollage to ALL,
        MetricsCenterStageCRI<*>::rpMural to ALL,
        MetricsCenterStageCRI<*>::rpFinale to ALL,
    )
}
